module.exports = __webpack_public_path__ + "img/mouth_male_average.eff789cc.png";